var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 17C20 17 20 3.5 20 3C20 2.5 19.5 2 19 2H3C2.5 2 2 2.5 2 3V17L9 9L12 13L14 11L20 17ZM17.875 5.5C17.875 6.63909 16.9516 7.5625 15.8125 7.5625C14.6734 7.5625 13.75 6.63909 13.75 5.5C13.75 4.36091 14.6734 3.4375 15.8125 3.4375C16.9516 3.4375 17.875 4.36091 17.875 5.5Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.987549 0 0 1 0 2.0625C0 2.0625 0 18.9875 0 20C0 21.0125 1 22 2 22H20C21 22 22 21.0125 22 20C22 18.9875 22 2 22 2C22 1 21.0125 0 20 0H2ZM1 2C1 1.5 1.5 1 2 1H20C20.5 1 21 1.5 21 2V20C21 20.5 20.5 21 20 21H2C1.5 21 1 20.5 1 20V2Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/Images.0acaf05e5395964fc9130afd9675128e.svg";
export { ForwardRef as ReactComponent };